module.exports = __webpack_public_path__ + "8359406b40472a5dce434b09492ed3fa.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-cowboy-s.png
// module id = 2872
// module chunks = 0